export default __webpack_public_path__ + "static/media/Close.02fb65f9.svg";